import DataTable from "datatables.net-react";
import "font-awesome/css/font-awesome.min.css";
import { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import { CashLedgerService } from "../../services/CashLedgerService";
import * as BullCache from "../../util/BullCache";
import From from '../components/From';
import To from '../components/To';
import { customStyles, the } from "../components/customStyles";
import "../custom.css";

function Cashledger() {
  const [loading, setLoading] = useState(false);
  const [admin, setAdmin] = useState([]);
  const [master, setMaster] = useState([]);
  const [broker, setBroker] = useState([]);
  const [client, setClient] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [selectedLastdate, setSelectedLastdate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [paymentlist, setPaymentlist] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [remark, setRemark] = useState("");
  const [paymentId, setPaymentId] = useState(null);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [calledFirstTime, setCalledFirstTime] = useState(false);




  const handleClose = () => setShowModal(false);

    var user = BullCache.getFromCache("user");
  const navigate = useNavigate();
  useEffect(() => {
    const currentDate = new Date();
    currentDate.setDate(1);
    const firstDayOfMonth = currentDate.toISOString().split("T")[0];

    setSelectedDate(firstDayOfMonth);
    setSelectedLastdate(new Date().toISOString().split("T")[0]);



    if (!user.adminId) return;

    CashLedgerService.getMasterbroker({ adminId: user.adminId }).then((res) => {
      if (res.code === 1) {
        if (res.data.adminList.length > 0) {
          setAdmin(res.data.adminList);
        }
        if (res.data.masterList.length > 0) {
          setMaster(res.data.masterList);
        }
        if (res.data.brokerList.length > 0) {
          setBroker(res.data.brokerList);
        }
      }
    });

    CashLedgerService.getUsers({ adminId: user.adminId }).then((res) => {
      if (res.code === 1) {
        if (res.data.userList.length > 0) {
          setClient(res.data.userList);
        }
      }
    });
  }, [user.adminId]);

  const handleRoleChange = (e) => {
    setSelectedBroker("");
    setSelectedRole(e.target.value);
  };

  const handleBrokerChange = (selectedOption) => {
    setSelectedBroker(selectedOption);
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleLastdateChange = (e) => {
    setSelectedLastdate(e.target.value);
  };

  const handleFromDateChange = (newDate) => {
    setFromDate(newDate);
    setSelectedDate(newDate);
  };
  const handleToDateChange = (newDate) => {
    setToDate(newDate);
    setSelectedLastdate(newDate);
  };
  useEffect(() => {
    if (fromDate && toDate && !calledFirstTime) {
      const dataToSubmit = {
        adminId: user.adminId,
        date: fromDate,
        endDate: toDate,
      };

      fetchData(dataToSubmit);
      setCalledFirstTime(true);
    }
  }, [fromDate, toDate]);

  const fetchData = (dataToSubmit) => {
    setLoading(true);
    CashLedgerService.getPaymentlist(dataToSubmit)
      .then((resp) => {
        setLoading(false);
        if (resp.code === 1 && resp.data.paymentList.length > 0) {
          setPaymentlist(resp.data.paymentList);
        } else {
          setPaymentlist([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching trade data:', error);
      });
  };



  const paymentSearch = () => {
    setLoading(true);
    const payment = {
      [selectedRole === "client" ? "userId" : "adminId"]: (selectedBroker != null ? selectedBroker.value : user.adminId),
      date: fromDate || selectedDate,
      endDate: toDate || selectedLastdate,
    };
    CashLedgerService.getPaymentlist(payment).then((resp) => {
      setLoading(false);
      if (resp.code === 1) {
        if (resp.data.paymentList.length > 0) {
          setPaymentlist(resp.data.paymentList);
        } else {
          setPaymentlist([]);
        }
      } else {
        setPaymentlist([]);
        Swal.fire({
          icon: "error",
          text: resp.messages,
        });
      }
    });
  };

  const handleSaveChanges = () => {
    const updatedPayment = {
      paymentId,
      amount,
      transactionType,
      remark,
      paymentType,
      createdDate: selectedDate,
    };

    CashLedgerService.updatePayment(updatedPayment).then(response => {
      if (response.code === 1) {
        Swal.fire({
          icon: "success",
          text: "Updated !",
        });
        const updatedList = paymentlist.map((payment) =>
          payment.paymentId === paymentId
            ? { ...payment, amount, transactionType, remark, paymentType, createdDate: selectedDate }
            : payment
        );
        setPaymentlist(updatedList);
        setShowModal(false);
      } else {
        Swal.fire({
          icon: "error",
          text: "Failed !",
        });
      }
    });
  };
  const getDropdownOptions = () => {
    let options = [];

    if (selectedRole === "admin" && admin.length > 0) {
      options = admin.map((a) => ({
        label: `${a.firstName} (${a.userName})`,
        value: a.adminId,
      }));
    }
    else if (selectedRole === "master" && master.length > 0) {
      options = master.map((m) => ({
        label: `${m.firstName} (${m.userName})`,
        value: m.adminId,
      }));
    } else if (selectedRole === "broker" && broker.length > 0) {
      options = broker.map((b) => ({
        label: `${b.firstName} (${b.userName})`,
        value: b.adminId,
      }));
    } else if (selectedRole === "client" && client.length > 0) {
      options = client.map((c) => ({
        label: `${c.firstName} (${c.userName})`,
        value: c.userid,
      }));
    }

    return options;
  };

  const handleDelete = (selectedPayment) => {
    const requestData = {
      adminId: user.adminId,
      paymentId: selectedPayment.paymentId,
    };

    CashLedgerService.deletePayment(requestData).then((res) => {
      if (res.code === 1) {
        Swal.fire({
          icon: "success",
          text: "Deleted Successfully!",
        });
        paymentSearch();
        handleClose();
      } else {
        Swal.fire({
          icon: "error",
          text: res.message || "Failed to Delete!",
        });
      }
    });
  };


  useEffect(() => {
    const handlePencilClick = (event) => {
      const paymentId = event.target.getAttribute("data-id");
      const selectedPayment = paymentlist.find(payment => payment.paymentId === paymentId);

      if (selectedPayment) {
        setPaymentId(selectedPayment.paymentId);
        setSelectedBroker(
          selectedPayment.userId
            ? `${selectedPayment.userId.firstName}` + ` (` + `${selectedPayment.userId.userName}` + `)`
            : `${selectedPayment.adminId.firstName}` + ` (` + ` ${selectedPayment.adminId.userName} ` + `)`
        );
        setSelectedDate(selectedPayment.createdDate);
        setAmount(selectedPayment.amount);
        setTransactionType(selectedPayment.transactionType);
        setPaymentType(selectedPayment.paymentType);
        setRemark(selectedPayment.remark);
        setShowModal(true);
      } else {
        console.error("Payment not found for paymentId: ", paymentId);
      }
    };

    const handleTrashClick = (event) => {
      const paymentId = event.target.getAttribute("data-id");
      const selectedPayment = paymentlist.find(payment => payment.paymentId === paymentId);
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No',
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          handleDelete(selectedPayment);
        }
      });

    };

    document.addEventListener("click", (event) => {
      if (event.target.classList.contains("icon-pencil")) {
        handlePencilClick(event);
      } else if (event.target.classList.contains("icon-trash")) {
        handleTrashClick(event);
      }
    });

    return () => {
      document.removeEventListener("click", handlePencilClick);
      document.removeEventListener("click", handleTrashClick);
    };
  }, [paymentlist]);

  const columns = [
    {
      title: "NAME",
      className: "text-center fss-1 font-bold ledger bg-body text-nowrap",
      render: (data, type, full, meta) => {
        if (full.userId != undefined) {
          return (
            full.userId.firstName +
            " (" +
            full.userId.userName +
            ")"
          );
        } else if (full.adminId != undefined) {
          return (
            full.adminId.firstName +
            " (" +
            full.adminId.userName +
            ")"
          );
        }
      },
    },
    {
      title: "DATE",
      data: "createdDate",
      className: " ledger bg-body text-center  font-bold fss-1 ",
    },
    {
      title: "DEBIT",
      data: "",
      className: " ledger bg-body text-center fss-1 ",
      render: (data, type, full, meta) => {
        if (full.transactionType === "WITHDRAW") {
          return full.amount;
        } else {
          return "-";
        }
      },
    },
    {
      title: "CREDIT",
      data: "",
      className: " ledger bg-body text-center fss-1 text-center font-bold ",
      render: (data, type, full, meta) => {
        if (full.transactionType === "DEPOSIT") {
          return full.amount;
        } else {
          return "-";
        }
      },
    },
    {
      title: "REMARK",
      data: "remark",
      className: " ledger bg-body text-center font-bold  fss-1 ",
    },
    {
      title: "ACTION",
      className: " ledger bg-body text-center font-bold  fss-1 text-nowrap",
      render: (data, type, full, meta) => {
        return `
        <i class="me-3 fa fa-pencil icon-pencil" data-id="${full.paymentId}" style="cursor: pointer"></i>
        <i class="icon-trash fa fa-trash" data-id="${full.paymentId}" style="cursor: pointer; color: red"></i>
      `;
      },
    },
  ];


  return (
    <div className="mb-4">
      <Card className="mt-2">
        <Card.Body>
          <Row>
            <Col sm={2} xs={6} className="text-start">
              <b className="h6 fss-05">SELECT ROLE</b>
              <Form.Select
                size="sm"
                aria-label="User Type"
                className="bg-light text-black"
                onChange={handleRoleChange}
                value={selectedRole}
              >
                <option value="">Select Role</option>

                {(() => {
                  if (user.adminType === "SUPER_ADMIN") {
                    return (
                      <>
                        <option value="admin">ADMIN</option>
                        <option value="master">MASTER</option>
                        <option value="broker">BROKER</option>
                        <option value="client">CLIENT</option>
                      </>
                    );
                  }
                  else if (user.adminType === "ADMIN") {
                    return (
                      <>
                        <option value="master">MASTER</option>
                        <option value="broker">BROKER</option>
                        <option value="client">CLIENT</option>
                      </>
                    );
                  } else if (user.adminType === "MASTER") {
                    return (
                      <>
                        <option value="broker">BROKER</option>
                        <option value="client">CLIENT</option>
                      </>
                    );
                  } else if (user.adminType === "BROKER") {
                    return (
                      <>
                        <option value="client">CLIENT</option>
                      </>
                    );
                  } else {
                    return null;
                  }
                })()}
              </Form.Select>
            </Col>

            <Col sm={2} xs={6} className="text-start">
              <b className="h6 fss-05">SELECT</b>
              <Select
                isSearchable
                isDisabled={!selectedRole}
                value={selectedBroker}
                onChange={handleBrokerChange}
                options={getDropdownOptions()}
                placeholder="Select"
                theme={the} styles={customStyles}
              />
            </Col>

            <Col sm={2} xs={6} xl={1} className=''>
              <b className='h6 fss-05'>FROM</b><br />
              <From fromDate={fromDate} onDateChange={handleFromDateChange} />
            </Col>
            <Col sm={2} xs={6} xl={1} className=''>
              <b className='h6 fss-05'> TO</b><br />
              <To toDate={toDate} setToDate={handleToDateChange} />
            </Col>

            <Col xs={4} sm={2} xl={1} className="mt-4 ms-2">
              <Button variant="success" size="sm w-75" onClick={paymentSearch}>
                <b className="fss-08">SUBMIT</b>
              </Button>
            </Col>

          </Row>
        </Card.Body>
      </Card>

      <Card className="mt-2 mb-5 ">
        <Card.Body className="ps-1 pe-1">
          <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <DataTable
                id="table"
                className=" table table-bordered bg-head-secondary fss-09 white-bordered-table"
                columns={columns}
                data={paymentlist}
              />
            )}
          </div>
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>EDIT LEDGER ENTRY</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg={2} sm={2} xs={2} className="fss-09">NAME:</Col> <Col lg={10} sm={10} xs={10}>{selectedBroker}</Col>
          </Row>
          <Row className="mt-3 border rounded p-1 ">
            <Col lg={5} sm={5} className="fss-09"><label>TRANSACTION TYPE  :</label></Col>
            <Col>
              <Form.Check
                type="radio"
                aria-label="radio 1"
                label="DEPOSIT"
                className="fss-875"
                name="group1"
                checked={transactionType === "DEPOSIT"}
                onChange={() => setTransactionType("DEPOSIT")}
              />
            </Col>
            <Col>
              <Form.Check
                type="radio"
                aria-label="radio 2"
                label="WITHDRAW"
                className="fss-875"
                name="group1"
                checked={transactionType === "WITHDRAW"}
                onChange={() => setTransactionType("WITHDRAW")}
              />
            </Col>
          </Row>
          <Row className="mt-3 border rounded p-1">
            <Col lg={5} sm={5} className="fss-09"><label>PAYMENT TYPE :</label></Col>

            <Col>
              <Form.Check
                type="radio"
                aria-label="radio 1"
                label="CASH"
                className="fss-875"
                name="group2"
                checked={paymentType === "CASH"}
                onChange={() => setPaymentType("CASH")}
              />
            </Col>
            <Col>
              <Form.Check
                type="radio"
                aria-label="radio 2"
                label="ONLINE"
                name="group2"
                className="fss-875"
                checked={paymentType === "ONLINE"}
                onChange={() => setPaymentType("ONLINE")}
              />
            </Col>
          </Row>

          <Row className="mt-2">
            <Col sm={12} className="fss-09">DATE</Col>
            <Col className="mt-1">
              <input
                type="date"
                size="lg"
                className="form-control"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <Col sm={12} className="fss-09">AMOUNT</Col>
            <Col className="mt-1">
              <input
                type="number"
                className="form-control"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="mt-3 fss-09">
              REMARK
            </Col>
            <Col className="mt-1">
              <Form.Control
                as="textarea"
                className="custom-placeholder"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
          <Button variant="success" onClick={handleSaveChanges}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Cashledger;
